import { signalSummary } from '../logic/signalCounts';
import { getApiKey } from '../data/api';
import { listDrafts } from '../data/drafts';
import { readStoredSignals } from '../data/signals';
import { getSnapshot } from '../data/store';
import { todayLocal } from '../logic/dates';
import { sidebarCounts } from '../logic/desk';
import type { SidebarCounts } from '../logic/desk';

/** The sidebar's counts (D65): follow-ups and leads from the mirror, new businesses from the stored
 *  list, drafts to send from the server — asked at most every 30 s, the last count kept offline. */
const DRAFTS_TTL_MS = 30_000;
let drafts: { count: number | null; at: number } = { count: null, at: 0 };

/** A draft changed: the next refresh asks the server again. */
export const forgetDraftCount = (): void => {
  drafts = { ...drafts, at: 0 };
};

export const pendingDrafts = async (): Promise<number | null> => {
  if (!getApiKey()) return null; // signed out: never ask (a 401 would sign the rep out again)
  if (Date.now() - drafts.at < DRAFTS_TTL_MS) return drafts.count;
  try {
    drafts = { count: (await listDrafts({ status: 'pending' })).length, at: Date.now() };
  } catch {
    drafts = { count: null, at: Date.now() };
  }
  return drafts.count;
};

export const loadSidebarCounts = async (): Promise<SidebarCounts> => {
  const [snap, stored, emails] = await Promise.all([getSnapshot(), readStoredSignals(), pendingDrafts()]);
  return sidebarCounts(snap.leads, snap.visits, stored ? signalSummary(stored.list).total : null, emails, todayLocal());
};
